<template>
  <div class="container" @click="maskClose">
    <div class="content-wrap">
      <div
        class="content"
        :style="{ backgroundImage: `url(${tipImgs[tipIndex - 1]})` }"
      >
        <img
          class="close"
          src="../../../../images/money_tree/dialog/close.png"
          @click="onClose"
        />

        <div class="go-to-wrap">
          <img
            class="btn-go"
            src="../../../../images/money_tree/dialog/btn_try_again.png"
            @click="onTryAgain"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  thankTip1Img,
  thankTip2Img,
  thankTip3Img,
  thankTip4Img,
  thankTip5Img
} from '@/defines/environment/config'
export default {
  data() {
    return {
      tipIndex: 1,
      tipImgs: [
        thankTip1Img,
        thankTip2Img,
        thankTip3Img,
        thankTip4Img,
        thankTip5Img
      ]
    }
  },

  mounted() {
    this.tipIndex = Math.floor(Math.random() * (1 - 5) + 5)
  },
  methods: {
    onClose() {
      this.$emit('close')
    },
    onTryAgain() {
      this.$emit('close')
      this.$emit('click')
    },
    maskClose() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  display: flex;

  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  flex-direction: column;
  justify-content: center;

  .content-wrap {
    display: flex;

    flex-direction: column;
    justify-content: center;
    align-items: center;

    .content {
      position: relative;

      width: 5.5rem;
      height: 6.6rem;

      overflow: hidden;

      background-repeat: no-repeat;
      background-size: 100% 100%;

      .close {
        position: absolute;
        top: 0;
        right: 0;

        width: 0.79rem;
        height: 0.79rem;
      }

      .go-to-wrap {
        position: absolute;
        bottom: 0;
        left: 0;

        width: 100%;

        text-align: center;

        .btn-go {
          width: 2.5rem;
          height: 1.06rem;
          overflow: hidden;

          background-repeat: no-repeat;
          background-size: 100% 100%;
        }
      }
    }
  }
}
</style>
